// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2i3IZ","filesListContainer":"PosDisputesFiles_filesListContainer__3Hltr","filesButton":"PosDisputesFiles_filesButton__3S5_y"};